
import { useState } from "react";

const BannerImage = ({ foto, titulo }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <li>
      <h3>{titulo}</h3>
      <img
        className={`banner-img ${loaded ? "loaded" : ""}`}
        src={foto}
        alt={titulo}
        loading="lazy"
        onLoad={() => setLoaded(true)}
      />
    </li>
  );
};

export default BannerImage;